import { FC } from 'react';

import { IconProps } from './types';

export const ShipmentIcon: FC<IconProps> = ({
	className,
	color = '#06519E',
	height = 48,
	size,
	width = 48,
}) => (
	<svg
		className={className}
		xmlns="http://www.w3.org/2000/svg"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			fill-rule="evenodd"
			d="M21.74 36.47A7.65 7.65 0 0 1 14.182 43a7.65 7.65 0 0 1-7.558-6.53H2.182A2.183 2.183 0 0 1 0 34.295V8.176C0 6.98.977 6 2.182 6h26.182c1.206 0 2.181.98 2.181 2.176v6.53h8.728c.589 0 1.134.24 1.549.631l3.993 3.983A10.9 10.9 0 0 1 48 27.025v7.27a2.186 2.186 0 0 1-2.182 2.176H43.55C43.025 40.149 39.84 43 36 43a7.65 7.65 0 0 1-7.558-6.53zM31 29.943a7.55 7.55 0 0 1 5.417-2.275A7.59 7.59 0 0 1 43.263 32H44v-5.07c0-1.733-.672-3.38-1.907-4.593L38.778 19H31zM26 32h-5.144c-1.238-2.596-3.89-4.4-6.956-4.4S8.182 29.404 6.944 32H4V10h22zm-11.5 0a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M33 35.5c0-1.937 1.563-3.5 3.5-3.5s3.5 1.563 3.5 3.5-1.563 3.5-3.5 3.5a3.495 3.495 0 0 1-3.5-3.5"
		/>
	</svg>
);
